export const getAutocompleteState = state => state.autocomplete;
